var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container" },
    [
      _c("div", { staticClass: "title" }, [_vm._v("会员详情")]),
      _vm._v(" "),
      _c(
        "el-descriptions",
        { attrs: { title: "", column: 1 } },
        [
          _c("el-descriptions-item", { attrs: { label: "用户名" } }, [
            _vm._v(_vm._s(_vm.info.name)),
          ]),
          _vm._v(" "),
          _c("el-descriptions-item", { attrs: { label: "手机号码" } }, [
            _vm._v(_vm._s(_vm.info.phone)),
          ]),
          _vm._v(" "),
          _c("el-descriptions-item", { attrs: { label: "注册时间" } }, [
            _vm._v(_vm._s(_vm.info.gmtCreated)),
          ]),
          _vm._v(" "),
          _c("el-descriptions-item", { attrs: { label: "性别" } }, [
            _vm._v(_vm._s(_vm.genderDic[_vm.info.sex])),
          ]),
          _vm._v(" "),
          _c("el-descriptions-item", { attrs: { label: "预付比例" } }, [
            _vm._v(
              _vm._s(_vm.info.advanceRatio ? _vm.info.advanceRatio + "%" : "")
            ),
          ]),
          _vm._v(" "),
          _c(
            "el-descriptions-item",
            { attrs: { label: "用户等级" } },
            [
              _c("el-tag", [
                _vm._v(_vm._s(_vm.info.distributor ? "分销商" : "普通用户")),
              ]),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }